@if (hasTaskLogPermission() && hasTaskLogs) {
  <p-button (onClick)="onShowDialog()" [outlined]="true" [rounded]="true" icon="pi pi-exclamation-triangle"/>
}

<p-dialog [(visible)]="dialogVisible" [modal]="true" [resizable]="false"
          [style]="{ width: '88rem', height:'58rem'}" [contentStyle]="{ 'overflow-y': 'auto', height: '100%' }"
          header="{{ 'shared.task-log.header' | translate }}">
  <ng-template pTemplate="content">
    <div class="flex flex-column h-full">
      @if (taskLogs.length !== 0) {
        <div class="flex flex-row align-content-center mt-3 pb-4 text-color-primary">
          <i [style]="{'margin-top':'2px'}" class="pi pi-info-circle font-semibold ml-2 mr-2"></i>
          <span> {{ "common.hint" | translate }}: {{ "shared.task-log.hint" | translate }}</span>
        </div>
      }
      @if (messageState()) {
        <div class="m-1">
          <p-message variant="outlined" [severity]="messageState()?.severity">
            {{ messageState()?.message }}
          </p-message>
        </div>
      }
      <div>
        <div class="flex flex-column flex-1">
          <p-table class="h-full" (onLazyLoad)="loadLazy($event)"
                   [(selection)]="selectedTaskLogs" [first]="first" [lazy]="true" [lazyLoadOnInit]="true"
                   [loading]="loading" [paginator]="true" scrollHeight="500px" scrollable="true"
                   [rows]="100" [showCurrentPageReport]="true" [sortOrder]="-1" [totalRecords]="totalRecords ?? 0"
                   paginatorDropdownAppendTo="body"
                   [value]="taskLogs" [rowsPerPageOptions]="[10, 25, 50, 100, 250]" dataKey="id"
                   paginatorPosition="both" sortField="logDate"
                   currentPageReportTemplate="{first} bis {last} von {totalRecords}">
            <ng-template pTemplate="header">
              <tr>
                <th class="p-1 pl-2" [style.width]="'3rem'">
                  <p-tableHeaderCheckbox/>
                </th>
                <th class="p-1" [style.width]="'15%'" pSortableColumn="logDate">
                  {{ "shared.task-log.date-time" | translate }}
                  <p-sortIcon field="logDate"/>
                </th>
                <th class="p-1" [style.width]="'15%'">
                  <div class="flex flex-row column-gap-2">
                    <div class="align-content-center">
                      {{ "shared.task-log.severity" | translate }}
                    </div>
                    <div>
                      <p-columnFilter #filter1 class="taskLogMenu" field="severity"
                                      [showAddButton]="false"
                                      [showMatchModes]="false" [showClearButton]="false" [showApplyButton]="false"
                                      matchMode="equals"
                                      [showOperator]="false" display="menu">
                        <ng-template let-filter="filterCallback" let-value pTemplate="filter">
                          <p-listbox [style]="{border: 0}" [options]="severityOptions" optionLabel="label"
                                     (onChange)="filter($event.value); filter1.hide()"
                                     optionValue="value" class="w-full"/>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                  </div>
                </th>
                <th class="p-1" [style.width]="'20%'">
                  <div class="flex flex-row column-gap-2">
                    <div class="align-content-center">
                      {{ "shared.task-log.task" | translate }}
                    </div>
                    <div>
                      <p-columnFilter #filter2 class="taskLogMenu" field="taskId" [showButtons]="false"
                                      [showMatchModes]="false" [showAddButton]="false" matchMode="equals"
                                      [showOperator]="false" display="menu" [showClearButton]="false"
                                      [showApplyButton]="false">
                        <ng-template let-filter="filterCallback" let-value pTemplate="filter">
                          <p-listbox [style]="{border: 0}" [options]="taskIdOptions" optionLabel="label"
                                     (onChange)="filter($event.value); filter2.hide()"
                                     optionValue="value" class="w-full"/>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                  </div>
                </th>
                <th>
                  {{ "shared.task-log.details" | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-taskLog>
              <tr>
                <td class="p-1 pl-2">
                  <p-tableCheckbox [value]="taskLog"/>
                </td>
                <td class="p-1">{{ taskLog.logDate | date: "dd.MM.yyyy HH:mm:ss" }}</td>
                <td class="p-1">{{ taskLog.severity }}</td>
                <td class="p-1 text-overflow-ellipsis">{{ taskLog.taskId }}</td>
                <td class="p-1 h-3rem text-overflow-ellipsis"><span
                  style="white-space: pre-line;">{{ taskLog.logMessage }}</span></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex flex-row w-full pt-2">
      <p-button class="ml-0" (onClick)="dialogVisible=false" severity="secondary" icon="pi pi-times" variant="outlined"
                label="{{ 'common.close' | translate }}" type="button"/>
      <div class="ml-auto">
        <p-button class="mr-4" (onClick)="confirmSelectedTaskLogs()" [disabled]="selectedTaskLogs.length === 0"
                  severity="primary" icon="pi pi-trash" variant="outlined" label="{{ 'common.delete' | translate }}"
                  type="button"/>
        <p-button (onClick)="onExport()" severity="primary" icon="pi pi-download" variant="outlined"
                  label="{{ 'common.export' | translate }}" type="button"/>
      </div>
    </div>
  </ng-template>
</p-dialog>
